import React from 'react';
import { Grid } from '../../../../core-components/grid';
import { Flex } from '../../../../next-components/Flex';
import { Image } from '../../../../next-components/image';
import { Rating } from '../../../Rating';
import { Typography } from '../../../Typography';
export type ChatHeaderProps = {
  chatHeaderImage: string;
  chatHeaderText: string;
};
export const ChatHeader = ({
  chatHeaderImage,
  chatHeaderText
}: ChatHeaderProps) => <Grid bg="#353F5B" gridTemplateColumns={'1fr'} borderRadius="8px 8px 0 0" p="8px" justifyContent="center" data-sentry-element="Grid" data-sentry-component="ChatHeader" data-sentry-source-file="ChatHeader.tsx">
    <Flex justifyContent="center" data-sentry-element="Flex" data-sentry-source-file="ChatHeader.tsx">
      <Image src={chatHeaderImage} alt="Chat Header Image" height="50px" width="130px" data-sentry-element="Image" data-sentry-source-file="ChatHeader.tsx" />
    </Flex>
    <Flex alignItems="center" justifyContent="center" data-sentry-element="Flex" data-sentry-source-file="ChatHeader.tsx">
      <Rating value={5} iconProps={{
      color: '#FABC44'
    }} data-sentry-element="Rating" data-sentry-source-file="ChatHeader.tsx" />
      <Typography color="white" fontSize="14px" m={0} pl="12px" textAlign="center" data-sentry-element="Typography" data-sentry-source-file="ChatHeader.tsx">
        {chatHeaderText}
      </Typography>
    </Flex>
  </Grid>;